import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import CustomRoute from 'CustomRoute';

function CustomRedirect({ from, to }) {

    const RedirectWrapper = () => {
        const location = useLocation();
        return <Redirect to={`${to}${location.search}`} />;
    };

    return <CustomRoute path={from} component={RedirectWrapper} />;
}

export default CustomRedirect;